export default __webpack_public_path__ + "static/media/hk416.30b72497.svg";